/** Arguments in the order the workspace web client's ApiError takes them (packages/web/src/api.ts; review C, R-14). */
export class ApiError extends Error {
  readonly status: number; readonly code: string | undefined;
  constructor(status: number, code: string | undefined, message: string) { super(message); this.name = 'ApiError'; this.status = status; this.code = code; }
}
/** The error a failed portal answer stands for: its body's code and message, or a generic message when it has none. */
export function apiError(status: number, body: unknown): ApiError {
  const error = (body as { error?: { code?: unknown; message?: unknown } } | null)?.error;
  return new ApiError(status, typeof error?.code === 'string' ? error.code : undefined, typeof error?.message === 'string' ? error.message : 'The request could not finish. Please try again.');
}
/** A request that got no answer at all: the browser's own words for that ('Failed to fetch', 'Load failed') mean nothing to the person reading them. */
export function networkError(): ApiError {
  return new ApiError(0, 'network', 'We couldn’t reach Obelisk. Check your connection and try again.');
}
